/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Side Nav Toolbox Icon component.
 */
export const SideNavManufacturingIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg xmlns="http://www.w3.org/2000/svg"
      width={iconSize}
      height={iconSize}
      viewBox="0 0 23 24"
      fill="none" >
      <path stroke={iconColor}
        strokeWidth={1.5}
        d="M6.1665 8.99801L11.173 11.8142C11.3759 11.9283 11.6237 11.9283 11.8267 11.8142L16.8332 8.99801M11.4998 11.998V17.998M12.0093 6.29969L16.3427 8.86548C16.6467 9.0455 16.8332 9.37261 16.8332 9.72595V14.5557C16.8332 14.9251 16.6295 15.2644 16.3035 15.4382L11.9701 17.7474C11.6762 17.904 11.3235 17.904 11.0296 17.7474L6.69622 15.4382C6.37019 15.2644 6.1665 14.9251 6.1665 14.5557V9.72595C6.1665 9.37261 6.35297 9.0455 6.65701 8.86548L10.9903 6.29969C11.3045 6.11365 11.6951 6.11365 12.0093 6.29969Z" />
      <path stroke={iconColor}
        strokeLinecap="round"
        strokeWidth={1.5}
        d="M16.7704 3.49805C15.2401 2.54719 13.4342 1.99805 11.5 1.99805C5.97715 1.99805 1.5 6.47521 1.5 11.9981C1.5 13.4203 1.79689 14.7731 2.33209 15.9981M20.6679 7.99805C21.2031 9.22298 21.5 10.5758 21.5 11.9981C21.5 17.5209 17.0228 21.9981 11.5 21.9981C9.5658 21.9981 7.75986 21.4489 6.22958 20.4981" />
      <path fill={iconColor}
        d="M18.3978 1.02148L19.3893 4.89665L15.5142 5.88816L18.3978 1.02148Z" />
      <path fill={iconColor}
        d="M4.60235 22.9779L3.61084 19.1028L7.486 18.1113L4.60235 22.9779Z" />
      <path stroke={iconColor}
        strokeWidth={0.5}
        d="M18.3978 1.02148L19.3893 4.89665L15.5142 5.88816L18.3978 1.02148Z" />
      <path stroke={iconColor}
        strokeWidth={0.5}
        d="M4.60235 22.9779L3.61084 19.1028L7.486 18.1113L4.60235 22.9779Z" />
    </svg>
  );
};
